import { Component, OnInit, Input } from '@angular/core';
import { FiltrosFormatoAsistencialEntity, NodoEntity } from '../../../../services/servicio-formato-asistencial.service';

@Component({
  selector: 'app-lista-desplegable',
  templateUrl: './lista-desplegable.component.html',
  styleUrls: ['./lista-desplegable.component.css']
})
export class ListaDesplegableComponent implements OnInit {

  @Input() nodo: NodoEntity;
  @Input() filtros: FiltrosFormatoAsistencialEntity;

  titulo: string;
  valor: string;

  constructor() { }

  ngOnInit() {
    if (this.nodo) {
      if (this.nodo.datos && this.nodo.datos.length > 0) {
        this.onProcess();
      } else {
        if (this.filtros.diligenciados) {
          setTimeout(() => {
            this.onDelete();
          }, 50);
        } else {
          this.onProcess();
        }
      }
    } else {
      this.titulo = '';
      this.valor = '';
    }
  }

  onProcess() {
    this.titulo = this.nodo.titulo;
    if (this.nodo.datos && this.nodo.datos.length > 0 && this.nodo.hijos && this.nodo.hijos.length > 0) {
      const value = Number(this.nodo.datos[0].valor);
      if (value > 0) {
        const option = this.nodo.hijos.find((hijo: any) => {
          return hijo.id === value;
        });
        option ? this.valor = option.titulo : this.valor = 'no seleccionado';
      }
    } else {
      this.valor = 'no seleccionado';
    }
  }

  onDelete() { }

}
